import React, { useEffect, useState } from "react";
import {
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  CardTitle,
  InputGroup,
  InputGroupAddon,
} from "reactstrap";
import NumberFormat from "react-number-format";
import WizardError from "../../auth/register/WizardError";
import { useSelector } from "react-redux";
import { toInteger } from "lodash";

const ProfileBasicAdmin = ({
  firstname,
  lastname,
  dni,
  edit,
  property,
  wasBeEdited,
  register,
  setValue,
  errors,
}) => {
  const { role } = useSelector((state) => state.auth.user);
  const [prefix, setPrefix] = useState("V");
  const [dnia, setDniA] = useState(null);

  register("firstname");
  register("lastname");
  register("dni");

  useEffect(() => {
    if (dni) {
      setDniA(toInteger(dni.substring(1, 40)));
      setPrefix(dni.charAt(0));
    }
  }, [dni]);

  return (
    <>
      <CardBody className="pb-0">
        <CardTitle tag="h5">Información básica</CardTitle>
        <Row form>
          <Col tag={FormGroup}>
            <Label htmlFor="dni">Doc. Identidad</Label>
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <Input
                  type="select"
                  value={prefix}
                  /* readOnly={role === 'manager' ? true : !edit} */ onChange={(
                    e
                  ) => {
                    setPrefix(e.target.value);
                    setValue("dni", `${e.target.value}${dnia}`);
                    wasBeEdited();
                  }}
                >
                  <option value="V">V</option>
                  <option value="E">E</option>
                  <option value="J">J</option>
                  <option value="P">P</option>
                  <option value="C">C</option>
                  <option value="G">G</option>
                </Input>
              </InputGroupAddon>
              <NumberFormat
                className="form-control"
                value={dnia || undefined}
                /* readOnly={role === 'manager' ? true : !edit} */
                onValueChange={({ value }) => {
                  setDniA(value);
                  setValue("dni", `${prefix}${value}`);
                  wasBeEdited();
                }}
                thousandSeparator="."
                decimalSeparator="," 
                decimalScale={0}
                renderText={(value, props) => <div {...props}>{value}</div>}
              />
            </InputGroup>
            {errors.dni && <WizardError error={errors?.dni?.message} />}
          </Col>
        </Row>
        <Row form>
          <Col tag={FormGroup}>
            <Label htmlFor="firstname">
              Nombres <span className="text-danger">*</span>
            </Label>
            <Input
              onChange={wasBeEdited}
              id="firstname"
              disabled={!edit}
              name="firstname"
              invalid={Boolean(errors.firstname)}
              innerRef={register({
                required: "Indica el nombre de este propietario.",
                pattern: {
                  value: /^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/i,
                  message: "Ingrese un nombre válido.",
                },
              })}
              className="form-control"
              defaultValue={firstname}
            />
            <WizardError
              error={errors.firstname?.message}
              className="mt-1"
            />
          </Col>
          <Col tag={FormGroup}>
            <Label htmlFor="lastname">
              Apellidos <span className="text-danger">*</span>
            </Label>
            <Input
              onChange={wasBeEdited}
              id="lastname"
              disabled={!edit}
              name="lastname"
              invalid={Boolean(errors.lastname)}
              innerRef={register({
                required: "Indica el apellido de este propietario.",
                pattern: {
                  value: /^[A-Za-zÁÉÍÓÚáéíóúñÑ ]+$/i,
                  message: "Ingrese un apellido válido.",
                },
              })}
              className="form-control"
              defaultValue={lastname}
            />
            <WizardError error={errors.lastname?.message} className="mt-1" />
          </Col>
        </Row>
        {/* HO-ISSUE-120: el inmueble era un campo suelto, sin marca de
        obligatorio y sin nada que dijera para qué sirve, así que se dejaba en
        blanco sin saber lo que se estaba perdiendo. Es lo que identifica a la
        unidad dentro del condominio: sin él, el propietario no se distingue
        del resto a la hora de asignarle gastos y el Excel de propietarios no
        lo vuelve a encontrar al reimportarlo. */}
        <Row form>
          <Col tag={FormGroup}>
            <Label htmlFor="house">
              Inmueble <span className="text-danger">*</span>
            </Label>
            {/* Sin el `required` de HTML a propósito: el navegador corta el
            envío con su propio globo ("Please fill out this field"), que sale
            en el idioma del navegador y no en el de la aplicación. La
            obligatoriedad la resuelve react-hook-form, que pinta el campo en
            rojo y deja el mensaje debajo, como el resto del formulario. */}
            <Input
              onChange={wasBeEdited}
              id="house"
              disabled={!edit}
              name="house"
              placeholder="Ej: Apto 4B, Casa 12, Local 3"
              invalid={Boolean(errors.house)}
              innerRef={register({
                required: "Indica el inmueble de este propietario.",
              })}
              className="form-control"
              defaultValue={property}
            />
            <small className="form-text text-muted">
              Es el nombre o número de la unidad dentro del condominio. Con él
              reconoces a este propietario cuando le asignas gastos, y es la
              columna con la que la carga por Excel vuelve a encontrar su
              unidad. No puede repetirse en el condominio.
            </small>
            <WizardError
              error={errors.house?.message}
              className="mt-1"
            />
          </Col>
        </Row>
      </CardBody>
    </>
  );
};

export default ProfileBasicAdmin;
